import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo12/clase.png";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad1Actividad3.mp3";

const Actividad5 = () => {
  const infoUnidad = modulo12.content[0];
  const infoAct = modulo12.content[0].activities[3];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo12.content[0].name}: ${modulo12.content[0].activities[4].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[4].path}`,
    titlePrev: `${modulo12.content[0].name}: ${modulo12.content[0].activities[2].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[2].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul className="mb-5">
        <li>Lee la historia y piensa. ¿Qué significa la palabra “excluido”?</li>
      </ul>
      <div className="row align-items-center">
        <div className="col-lg-4 col-12">
          <p className="fs-5">
            Soy Mónica Quevedo y enseño en un colegio. Cuando un alumno llega de
            fuera a veces es <strong>excluido</strong> porque se viste distinto
            o habla diferente. Entonces, conversamos entre todos para conocer de
            dónde vienen nuestras familias
          </p>
        </div>
        <div className="col-lg-8 col-12">
          <img src={Imagen1} alt="Clase" className="img-fluid" />
        </div>
      </div>
      <GuiaDocente>
        <ul>
          <li>
            Lea en voz alta la indicación: Lee la historia y piensa. ¿Qué
            significa la palabra "excluido"?
          </li>

          <li>Pida que lean el párrafo en silencio.</li>

          <li>
            Pregunte qué significa la palabra "excluido". Por ejemplo:
            "Separado, marginado, etc."
          </li>

          <li>
            Pida que den un ejemplo en el que usen la palabra en una oración.
          </li>

          <li>
            Pregunte cuál es el antónimo de "excluido". Recuérdeles que los
            antónimos son palabras que significan lo opuesto. Para determinar el
            antónimo de la palabra "excluido" pueden revisar la actividad
            anterior.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
